import { Field } from 'react-final-form'
import Select from 'react-select';
import { handleFocus, handleBlur } from '../AnimationHandler'
import stylesDropdown from '../stylesDropdown'


function Dropdown({ name, type, label, options = [], afterChange = null, active = false, withAnimate = true }) {

  const handleInputChange = (value, input) => {
    input.onChange(value)

    if(afterChange !== null) {
      afterChange(value)
    }
  }

	const renderError = ({touched, data: { error: metaErrro}, submitting}) => {
		if((metaErrro) && (touched || submitting)) {
			return (
				<div className="field-error-message">
					{ metaErrro }
				</div>
			)
		}
	}

	return (
    <Field name={name} >
			{({ input, meta }) => {
				return (
          <>
            <div 
              className={"float-container " + 
                ((meta.data.error) && (meta.touched || meta.submitting) 
                  ? 'error' : '')+(input.value != '' || meta.active ? ' active' : '')
              }
            >
              {label && <label htmlFor={name}>{ label }</label>}
              <Select
                value={input.value}
                className="dropdown-search-container"
                classNamePrefix="dropdown-search"
                styles={stylesDropdown}
                options={options}
                onChange={(value) => handleInputChange(value, input)}
                isSearchable={false}
                onFocus={(e) => {
                  handleFocus(e) 
                  input.onFocus(e)
                }}
                onBlur={(e) => {
                  handleBlur(e, input) 
                  input.onBlur(e)
                }}
                inputId={name}
                placeholder=""
              />
            </div>
            { renderError(meta) }
          </>
				)
			}}
		</Field>
	)

}

export default Dropdown;
